<template>
    <div class="main-container" :key="userLang">
        <!-- :key="$root.language.language.code" -->
        <w-header :nav="headerNav"></w-header>

        <transition name="fade" mode="out-in">
            <router-view :key="animationKey"></router-view>
        </transition>

        <w-cookies-popup></w-cookies-popup>

<!--        <w-footer :nav="footerNav"></w-footer>-->
      <footer class="true-bottom">
        <div class="true-footer">
          <div class="container">
            <div class="left">
              <div>
                <strong>TRUE World</strong>
                <div class="links">
                  <router-link :to="{ name: 'vision'}">TRUE Vision</router-link>
                  <router-link :to="{ name: 'saga'}">Explore the Saga</router-link>
                  <!--            <a href="#">Games</a>-->
                  <!--            <a href="#">Where to Play</a>-->
                  <router-link :to="{ name: 'world', hash: '#game'}">Truecoin Game</router-link>
                </div>
              </div>
              <div>
                <strong>Ecosystem</strong>
                <div class="links">
                  <router-link :to="{ path: '/ecosystem#performance'}">Performance Metrics</router-link>
                  <router-link :to="{ name: 'ecosystem', hash: '#team'}">Team</router-link>
                  <router-link :to="{ name: 'ecosystem', hash: '#supported'}">Backers</router-link>
                  <router-link :to="{ name: 'ecosystem', hash: '#partners'}">Partners</router-link>
                  <router-link :to="{ name: 'ecosystem', hash: '#roadmap'}">Roadmap</router-link>
                  <a href="https://wiki.true.world/Pitch-Deck-185d90f8c006805a96dbe791b3342b3a">Pitch Deck</a>
                  <a href="https://wiki.true.world/White-Paper-EN-177d90f8c00680268e9fdbb49d7911bd">White Paper</a>
                </div>
              </div>
              <div>
                <strong>Community</strong>
                <div class="links">
                  <router-link :to="{ name: 'community', hash: '#connect'}">Connect</router-link>
                  <router-link :to="{ name: 'community', hash: '#news'}">News</router-link>
                  <router-link :to="{ name: 'community', hash: '#statuses'}">Statuses</router-link>
                  <router-link :to="{ name: 'community', hash: '#benefits'}">Benefits</router-link>
                </div>
              </div>
              <div>
                <strong>Token</strong>
                <div class="links">
                  <router-link :to="{ name: 'token' }">About $TRUE</router-link>
<!--                  <a href="#">Buy token</a>-->
                </div>
              </div>
            </div>
            <div>
              <div>
                <strong>X (twitter)</strong>
                <div class="links">
                  <a href="https://x.com/TRUE_Ecosystem" target="_blank">
                    TRUE Ecosystem
                    <img src="/images/external.svg">
                  </a>
                  <a href="https://x.com/TRUExWorld" target="_blank">
                    TRUE World
                    <img src="/images/external.svg">
                  </a>
                  <a href="https://x.com/TRUExGames" target="_blank">
                    TRUE Games
                    <img src="/images/external.svg">
                  </a>
                  <a href="https://x.com/TRUExCEO" target="_blank">
                    TRUE CEO
                    <img src="/images/external.svg">
                  </a>
                  <a href="https://x.com/TRUExRock" target="_blank">
                    Dr. Rock
                    <img src="/images/external.svg">
                  </a>
                </div>
              </div>
              <div class="languages">
                <strong>Languages <span>Soon</span></strong>
                <div class="links">
                  <a href="#">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.6" clip-path="url(#clip0_6118_47598)">
                        <path d="M7.97578 0.5C4.72578 0.5 1.95078 2.6 0.925781 5.5H15.0758C14.0258 2.6 11.2508 0.5 7.97578 0.5Z" fill="#F9F9F9"/>
                        <path d="M7.97578 15.5C11.2508 15.5 14.0258 13.4 15.0508 10.5H0.925781C1.95078 13.425 4.72578 15.5 7.97578 15.5Z" fill="#ED4C5C"/>
                        <path d="M0.925 5.5C0.65 6.275 0.5 7.125 0.5 8C0.5 8.875 0.65 9.725 0.925 10.5H15.075C15.35 9.725 15.5 8.875 15.5 8C15.5 7.125 15.35 6.275 15.075 5.5H0.925Z" fill="#428BC1"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_6118_47598">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>

                    Russian
                  </a>
                  <a href="#">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.6" clip-path="url(#clip0_6118_47602)">
                        <path d="M8 15.5C12.15 15.5 15.5 12.15 15.5 8H0.5C0.5 12.15 3.85 15.5 8 15.5Z" fill="#FFE62E"/>
                        <path d="M8 0.5C3.85 0.5 0.5 3.85 0.5 8H15.5C15.5 3.85 12.15 0.5 8 0.5Z" fill="#428BC1"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_6118_47602">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>

                    Ukranian
                  </a>
                  <a href="#">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.6" clip-path="url(#clip0_6118_47605)">
                        <path d="M4.25 14.5V1.5C2 2.8 0.5 5.225 0.5 8C0.5 10.775 2 13.2 4.25 14.5Z" fill="#699635"/>
                        <path d="M8 0.5C6.625 0.5 5.35 0.875 4.25 1.5V14.5C5.35 15.15 6.625 15.5 8 15.5C12.15 15.5 15.5 12.15 15.5 8C15.5 3.85 12.15 0.5 8 0.5Z" fill="#ED4C5C"/>
                        <path d="M4.25 5C2.6 5 1.25 6.35 1.25 8C1.25 9.65 2.6 11 4.25 11C5.9 11 7.25 9.65 7.25 8C7.25 6.35 5.9 5 4.25 5ZM4.25 10.625C2.8 10.625 1.625 9.45 1.625 8C1.625 6.55 2.8 5.375 4.25 5.375C5.7 5.375 6.875 6.55 6.875 8C6.875 9.45 5.7 10.625 4.25 10.625Z" fill="#FFE62E"/>
                        <path d="M5.27422 10.9219C5.22422 10.9719 5.14922 10.9719 5.09922 10.9219L1.67422 6.39687C1.62422 6.34687 1.62422 6.27187 1.67422 6.22187L1.74922 6.14688C1.79922 6.09688 1.87422 6.09688 1.92422 6.14688L5.34922 10.6719C5.39922 10.7219 5.39922 10.7969 5.34922 10.8469L5.27422 10.9219Z" fill="#FFE62E"/>
                        <path d="M4.30078 4.875C4.37578 4.875 4.42578 4.925 4.42578 5V11C4.42578 11.075 4.37578 11.125 4.30078 11.125H4.17578C4.10078 11.125 4.05078 11.075 4.05078 11V5C4.05078 4.925 4.10078 4.875 4.17578 4.875H4.30078Z" fill="#FFE62E"/>
                        <path d="M7.2253 8.32882L4.2503 7.80382V8.17882L7.1753 8.70382C7.2503 8.70382 7.3003 8.67882 7.3253 8.60382L7.3503 8.47882C7.3503 8.42882 7.3003 8.35382 7.2253 8.32882ZM4.2503 7.77882L1.9003 6.12882C1.8503 6.07882 1.7753 6.10382 1.7253 6.15382L1.6503 6.25382C1.6003 6.30382 1.6253 6.37882 1.6753 6.42882L4.2503 8.22882V7.77882Z" fill="#FFE62E"/>
                        <path d="M4.1504 7.5L1.8004 9.85C1.7504 9.9 1.7504 9.975 1.8004 10.025L1.9004 10.125C1.9504 10.175 2.0254 10.175 2.0754 10.125L4.1504 8.05V7.5ZM4.2504 6.375L1.1254 7.85C1.0754 7.875 1.0254 7.95 1.0754 8.025L1.1254 8.15C1.1504 8.2 1.2254 8.25 1.3004 8.2L4.2504 6.8V6.375Z" fill="#FFE62E"/>
                        <path d="M7.02578 6.79844L4.05078 6.27344V6.64844L6.97578 7.17344C7.05078 7.17344 7.10078 7.14844 7.12578 7.07344L7.15078 6.94844C7.12578 6.87344 7.07578 6.79844 7.02578 6.79844ZM4.22578 9.72344C4.17578 9.74844 4.12578 9.82344 4.17578 9.89844L4.22578 10.0234C4.25078 10.0734 4.32578 10.1234 4.40078 10.0734L6.90078 8.92344L7.02578 8.44844L4.22578 9.72344ZM4.22578 8.87344L1.42578 7.84844V8.24844L4.22578 9.27344V8.87344Z" fill="#FFE62E"/>
                        <path d="M2.27539 9.70312V10.0781L5.97539 10.3281C6.12539 10.2281 6.25039 10.1031 6.37539 9.97813L2.27539 9.70312Z" fill="#FFE62E"/>
                        <path d="M3 6.75V8.5C3 9.2 3.55 9.75 4.25 9.75C4.95 9.75 5.5 9.2 5.5 8.5V6.75H3Z" fill="white"/>
                        <path d="M4.25 10.25C3.275 10.25 2.5 9.475 2.5 8.5V6.25H6V8.5C6 9.475 5.225 10.25 4.25 10.25ZM3.5 7.25V8.5C3.5 8.925 3.825 9.25 4.25 9.25C4.675 9.25 5 8.925 5 8.5V7.25H3.5Z" fill="#ED4C5C"/>
                        <path d="M4.02539 7.35313V7.75313C4.02539 7.82813 4.07539 7.87813 4.15039 7.87813H4.35039C4.42539 7.87813 4.47539 7.82813 4.47539 7.75313V7.32812H4.02539V7.35313ZM4.02539 7.97813V8.40312C4.02539 8.47812 4.07539 8.52812 4.15039 8.52812H4.35039C4.42539 8.52812 4.47539 8.47812 4.47539 8.40312V7.97813H4.02539ZM3.52539 7.97813V8.40312C3.52539 8.47812 3.57539 8.52812 3.65039 8.52812H3.85039C3.92539 8.52812 3.97539 8.47812 3.97539 8.40312V7.97813H3.52539ZM4.52539 7.97813V8.40312C4.52539 8.47812 4.57539 8.52812 4.65039 8.52812H4.85039C4.92539 8.52812 4.97539 8.47812 4.97539 8.40312V7.97813H4.52539ZM4.02539 8.57812V9.00313C4.02539 9.07813 4.07539 9.12813 4.15039 9.12813H4.35039C4.42539 9.12813 4.47539 9.07813 4.47539 9.00313V8.57812H4.02539Z" fill="#0071BC"/>
                        <path d="M4.24922 8.27187C4.27683 8.27187 4.29922 8.24949 4.29922 8.22188C4.29922 8.19426 4.27683 8.17188 4.24922 8.17188C4.2216 8.17188 4.19922 8.19426 4.19922 8.22188C4.19922 8.24949 4.2216 8.27187 4.24922 8.27187Z" fill="white"/>
                        <path d="M4.14961 8.39687C4.17722 8.39687 4.19961 8.37449 4.19961 8.34688C4.19961 8.31926 4.17722 8.29688 4.14961 8.29688C4.122 8.29688 4.09961 8.31926 4.09961 8.34688C4.09961 8.37449 4.122 8.39687 4.14961 8.39687Z" fill="white"/>
                        <path d="M4.34883 8.39687C4.37644 8.39687 4.39883 8.37449 4.39883 8.34688C4.39883 8.31926 4.37644 8.29688 4.34883 8.29688C4.32121 8.29688 4.29883 8.31926 4.29883 8.34688C4.29883 8.37449 4.32121 8.39687 4.34883 8.39687Z" fill="white"/>
                        <path d="M4.14961 8.14687C4.17722 8.14687 4.19961 8.12449 4.19961 8.09688C4.19961 8.06926 4.17722 8.04688 4.14961 8.04688C4.122 8.04688 4.09961 8.06926 4.09961 8.09688C4.09961 8.12449 4.122 8.14687 4.14961 8.14687Z" fill="white"/>
                        <path d="M4.34883 8.14687C4.37644 8.14687 4.39883 8.12449 4.39883 8.09688C4.39883 8.06926 4.37644 8.04688 4.34883 8.04688C4.32121 8.04688 4.29883 8.06926 4.29883 8.09688C4.29883 8.12449 4.32121 8.14687 4.34883 8.14687Z" fill="white"/>
                        <path d="M4.24922 7.64687C4.27683 7.64687 4.29922 7.62449 4.29922 7.59687C4.29922 7.56926 4.27683 7.54688 4.24922 7.54688C4.2216 7.54688 4.19922 7.56926 4.19922 7.59687C4.19922 7.62449 4.2216 7.64687 4.24922 7.64687Z" fill="white"/>
                        <path d="M4.14961 7.77187C4.17722 7.77187 4.19961 7.74949 4.19961 7.72187C4.19961 7.69426 4.17722 7.67188 4.14961 7.67188C4.122 7.67188 4.09961 7.69426 4.09961 7.72187C4.09961 7.74949 4.122 7.77187 4.14961 7.77187Z" fill="white"/>
                        <path d="M4.34883 7.77187C4.37644 7.77187 4.39883 7.74949 4.39883 7.72187C4.39883 7.69426 4.37644 7.67188 4.34883 7.67188C4.32121 7.67188 4.29883 7.69426 4.29883 7.72187C4.29883 7.74949 4.32121 7.77187 4.34883 7.77187Z" fill="white"/>
                        <path d="M4.14961 7.52187C4.17722 7.52187 4.19961 7.49949 4.19961 7.47187C4.19961 7.44426 4.17722 7.42188 4.14961 7.42188C4.122 7.42188 4.09961 7.44426 4.09961 7.47187C4.09961 7.49949 4.122 7.52187 4.14961 7.52187Z" fill="white"/>
                        <path d="M4.34883 7.52187C4.37644 7.52187 4.39883 7.49949 4.39883 7.47187C4.39883 7.44426 4.37644 7.42188 4.34883 7.42188C4.32121 7.42188 4.29883 7.44426 4.29883 7.47187C4.29883 7.49949 4.32121 7.52187 4.34883 7.52187Z" fill="white"/>
                        <path d="M4.74922 8.27187C4.77683 8.27187 4.79922 8.24949 4.79922 8.22188C4.79922 8.19426 4.77683 8.17188 4.74922 8.17188C4.7216 8.17188 4.69922 8.19426 4.69922 8.22188C4.69922 8.24949 4.7216 8.27187 4.74922 8.27187Z" fill="white"/>
                        <path d="M4.64961 8.39687C4.67722 8.39687 4.69961 8.37449 4.69961 8.34688C4.69961 8.31926 4.67722 8.29688 4.64961 8.29688C4.622 8.29688 4.59961 8.31926 4.59961 8.34688C4.59961 8.37449 4.622 8.39687 4.64961 8.39687Z" fill="white"/>
                        <path d="M4.84883 8.39687C4.87644 8.39687 4.89883 8.37449 4.89883 8.34688C4.89883 8.31926 4.87644 8.29688 4.84883 8.29688C4.82121 8.29688 4.79883 8.31926 4.79883 8.34688C4.79883 8.37449 4.82121 8.39687 4.84883 8.39687Z" fill="white"/>
                        <path d="M4.64961 8.14687C4.67722 8.14687 4.69961 8.12449 4.69961 8.09688C4.69961 8.06926 4.67722 8.04688 4.64961 8.04688C4.622 8.04688 4.59961 8.06926 4.59961 8.09688C4.59961 8.12449 4.622 8.14687 4.64961 8.14687Z" fill="white"/>
                        <path d="M4.84883 8.14687C4.87644 8.14687 4.89883 8.12449 4.89883 8.09688C4.89883 8.06926 4.87644 8.04688 4.84883 8.04688C4.82121 8.04688 4.79883 8.06926 4.79883 8.09688C4.79883 8.12449 4.82121 8.14687 4.84883 8.14687Z" fill="white"/>
                        <path d="M3.74922 8.27187C3.77683 8.27187 3.79922 8.24949 3.79922 8.22188C3.79922 8.19426 3.77683 8.17188 3.74922 8.17188C3.7216 8.17188 3.69922 8.19426 3.69922 8.22188C3.69922 8.24949 3.7216 8.27187 3.74922 8.27187Z" fill="white"/>
                        <path d="M3.64961 8.39687C3.67722 8.39687 3.69961 8.37449 3.69961 8.34688C3.69961 8.31926 3.67722 8.29688 3.64961 8.29688C3.622 8.29688 3.59961 8.31926 3.59961 8.34688C3.59961 8.37449 3.622 8.39687 3.64961 8.39687Z" fill="white"/>
                        <path d="M3.84883 8.39687C3.87644 8.39687 3.89883 8.37449 3.89883 8.34688C3.89883 8.31926 3.87644 8.29688 3.84883 8.29688C3.82121 8.29688 3.79883 8.31926 3.79883 8.34688C3.79883 8.37449 3.82121 8.39687 3.84883 8.39687Z" fill="white"/>
                        <path d="M3.64961 8.14687C3.67722 8.14687 3.69961 8.12449 3.69961 8.09688C3.69961 8.06926 3.67722 8.04688 3.64961 8.04688C3.622 8.04688 3.59961 8.06926 3.59961 8.09688C3.59961 8.12449 3.622 8.14687 3.64961 8.14687Z" fill="white"/>
                        <path d="M3.84883 8.14687C3.87644 8.14687 3.89883 8.12449 3.89883 8.09688C3.89883 8.06926 3.87644 8.04688 3.84883 8.04688C3.82121 8.04688 3.79883 8.06926 3.79883 8.09688C3.79883 8.12449 3.82121 8.14687 3.84883 8.14687Z" fill="white"/>
                        <path d="M4.24922 8.89687C4.27683 8.89687 4.29922 8.87449 4.29922 8.84688C4.29922 8.81926 4.27683 8.79688 4.24922 8.79688C4.2216 8.79688 4.19922 8.81926 4.19922 8.84688C4.19922 8.87449 4.2216 8.89687 4.24922 8.89687Z" fill="white"/>
                        <path d="M4.14961 9.02187C4.17722 9.02187 4.19961 8.99949 4.19961 8.97188C4.19961 8.94426 4.17722 8.92188 4.14961 8.92188C4.122 8.92188 4.09961 8.94426 4.09961 8.97188C4.09961 8.99949 4.122 9.02187 4.14961 9.02187Z" fill="white"/>
                        <path d="M4.34883 9.02187C4.37644 9.02187 4.39883 8.99949 4.39883 8.97188C4.39883 8.94426 4.37644 8.92188 4.34883 8.92188C4.32121 8.92188 4.29883 8.94426 4.29883 8.97188C4.29883 8.99949 4.32121 9.02187 4.34883 9.02187Z" fill="white"/>
                        <path d="M4.14961 8.77187C4.17722 8.77187 4.19961 8.74949 4.19961 8.72188C4.19961 8.69426 4.17722 8.67188 4.14961 8.67188C4.122 8.67188 4.09961 8.69426 4.09961 8.72188C4.09961 8.74949 4.122 8.77187 4.14961 8.77187Z" fill="white"/>
                        <path d="M4.34883 8.77187C4.37644 8.77187 4.39883 8.74949 4.39883 8.72188C4.39883 8.69426 4.37644 8.67188 4.34883 8.67188C4.32121 8.67188 4.29883 8.69426 4.29883 8.72188C4.29883 8.74949 4.32121 8.77187 4.34883 8.77187Z" fill="white"/>
                        <path d="M4 7H4.5L4.45 6.75V6.5H4.5V6.375H4.425V6.45H4.4V6.375H4.325V6.45H4.275V6.375H4.225V6.45H4.175V6.375H4.1V6.45H4.05V6.375H4V6.5H4.05V6.75L4 7Z" fill="#FFE62E"/>
                        <path d="M4.32461 6.99844H4.29961V6.89844C4.29961 6.87344 4.27461 6.84844 4.24961 6.84844C4.22461 6.84844 4.19961 6.87344 4.19961 6.89844V6.99844H4.17461V6.89844C4.17461 6.84844 4.19961 6.82344 4.24961 6.82344C4.29961 6.82344 4.32461 6.84844 4.32461 6.89844V6.99844ZM4.24961 6.72344H4.09961V6.59844C4.09961 6.54844 4.12461 6.52344 4.17461 6.52344C4.22461 6.52344 4.24961 6.54844 4.24961 6.59844V6.72344ZM4.12461 6.69844H4.22461V6.59844C4.22461 6.57344 4.19961 6.54844 4.17461 6.54844C4.14961 6.54844 4.12461 6.57344 4.12461 6.59844V6.69844ZM4.39961 6.72344H4.24961V6.59844C4.24961 6.54844 4.27461 6.52344 4.32461 6.52344C4.37461 6.52344 4.39961 6.54844 4.39961 6.59844V6.72344ZM4.27461 6.69844H4.37461V6.59844C4.37461 6.57344 4.34961 6.54844 4.32461 6.54844C4.29961 6.54844 4.27461 6.57344 4.27461 6.59844V6.69844Z" fill="#3E4347"/>
                        <path d="M2.75 7H3.25L3.2 6.75V6.5H3.25V6.375H3.175V6.45H3.15V6.375H3.075V6.45H3.025V6.375H2.975V6.45H2.925V6.375H2.85V6.45H2.8V6.375H2.75V6.5H2.8V6.75L2.75 7Z" fill="#FFE62E"/>
                        <path d="M3.07461 6.99844H3.04961V6.89844C3.04961 6.87344 3.02461 6.84844 2.99961 6.84844C2.97461 6.84844 2.94961 6.87344 2.94961 6.89844V6.99844H2.92461V6.89844C2.92461 6.84844 2.94961 6.82344 2.99961 6.82344C3.04961 6.82344 3.07461 6.84844 3.07461 6.89844V6.99844ZM2.99961 6.72344H2.84961V6.59844C2.84961 6.54844 2.87461 6.52344 2.92461 6.52344C2.97461 6.52344 2.99961 6.54844 2.99961 6.59844V6.72344ZM2.87461 6.69844H2.97461V6.59844C2.97461 6.57344 2.94961 6.54844 2.92461 6.54844C2.89961 6.54844 2.87461 6.57344 2.87461 6.59844V6.69844Z" fill="#3E4347"/>
                        <path d="M3.15 6.72344H3V6.59844C3 6.54844 3.025 6.52344 3.075 6.52344C3.125 6.52344 3.15 6.54844 3.15 6.59844V6.72344ZM3.025 6.69844H3.125V6.59844C3.125 6.57344 3.1 6.54844 3.075 6.54844C3.05 6.54844 3.025 6.57344 3.025 6.59844V6.69844Z" fill="#3E4347"/>
                        <path d="M2.75 8.47656H3.25L3.2 8.22656V7.97656H3.25V7.85156H3.2V7.92656H3.15V7.85156H3.1V7.92656H3.025V7.85156H2.975V7.92656H2.925V7.85156H2.875V7.92656H2.825V7.85156H2.75V7.97656H2.825V8.22656L2.75 8.47656Z" fill="#FFE62E"/>
                        <path d="M3.07461 8.475H3.04961V8.375C3.04961 8.35 3.02461 8.325 2.99961 8.325C2.97461 8.325 2.94961 8.35 2.94961 8.375V8.475H2.92461V8.375C2.92461 8.325 2.94961 8.3 2.99961 8.3C3.04961 8.3 3.07461 8.325 3.07461 8.375V8.475ZM2.99961 8.2H2.84961V8.075C2.84961 8.025 2.87461 8 2.92461 8C2.97461 8 2.99961 8.025 2.99961 8.075V8.2ZM2.87461 8.175H2.97461V8.075C2.97461 8.05 2.94961 8.025 2.92461 8.025C2.89961 8.025 2.87461 8.05 2.87461 8.075V8.175ZM3.17461 8.2H3.02461V8.075C3.02461 8.025 3.04961 8 3.09961 8C3.14961 8 3.17461 8.025 3.17461 8.075V8.2ZM3.04961 8.175H3.14961V8.075C3.14961 8.05 3.12461 8.025 3.09961 8.025C3.07461 8.025 3.04961 8.05 3.04961 8.075V8.175Z" fill="#3E4347"/>
                        <path d="M5.25 8.49844H5.75L5.7 8.24844V7.99844H5.75V7.89844H5.675V7.94844H5.65V7.89844H5.575V7.94844H5.525V7.89844H5.475V7.94844H5.425V7.89844H5.35V7.94844H5.3V7.89844H5.25V7.99844H5.3V8.24844L5.25 8.49844Z" fill="#FFE62E"/>
                        <path d="M5.57461 8.49844H5.54961V8.39844C5.54961 8.37344 5.52461 8.34844 5.49961 8.34844C5.47461 8.34844 5.44961 8.37344 5.44961 8.39844V8.49844H5.42461V8.39844C5.42461 8.34844 5.44961 8.32344 5.49961 8.32344C5.54961 8.32344 5.57461 8.34844 5.57461 8.39844V8.49844ZM5.49961 8.22344H5.34961V8.09844C5.34961 8.04844 5.37461 8.02344 5.42461 8.02344C5.47461 8.02344 5.49961 8.04844 5.49961 8.09844V8.22344ZM5.37461 8.19844H5.47461V8.09844C5.47461 8.07344 5.44961 8.04844 5.42461 8.04844C5.39961 8.04844 5.37461 8.07344 5.37461 8.09844V8.19844ZM5.64961 8.22344H5.49961V8.09844C5.49961 8.04844 5.52461 8.02344 5.57461 8.02344C5.62461 8.02344 5.64961 8.04844 5.64961 8.09844V8.22344ZM5.52461 8.19844H5.62461V8.09844C5.62461 8.07344 5.59961 8.04844 5.57461 8.04844C5.54961 8.04844 5.52461 8.07344 5.52461 8.09844V8.19844Z" fill="#3E4347"/>
                        <path d="M5.25 7H5.75L5.7 6.75V6.5H5.75V6.375H5.675V6.45H5.65V6.375H5.575V6.45H5.525V6.375H5.475V6.45H5.425V6.375H5.35V6.45H5.3V6.375H5.25V6.5H5.3V6.75L5.25 7Z" fill="#FFE62E"/>
                        <path d="M5.57461 6.99844H5.54961V6.89844C5.54961 6.87344 5.52461 6.84844 5.49961 6.84844C5.47461 6.84844 5.44961 6.87344 5.44961 6.89844V6.99844H5.42461V6.89844C5.42461 6.84844 5.44961 6.82344 5.49961 6.82344C5.54961 6.82344 5.57461 6.84844 5.57461 6.89844V6.99844ZM5.49961 6.72344H5.34961V6.59844C5.34961 6.54844 5.37461 6.52344 5.42461 6.52344C5.47461 6.52344 5.49961 6.54844 5.49961 6.59844V6.72344ZM5.37461 6.69844H5.47461V6.59844C5.47461 6.57344 5.44961 6.54844 5.42461 6.54844C5.39961 6.54844 5.37461 6.57344 5.37461 6.59844V6.69844ZM5.64961 6.72344H5.49961V6.59844C5.49961 6.54844 5.52461 6.52344 5.57461 6.52344C5.62461 6.52344 5.64961 6.54844 5.64961 6.59844V6.72344ZM5.52461 6.69844H5.62461V6.59844C5.62461 6.57344 5.59961 6.54844 5.57461 6.54844C5.54961 6.54844 5.52461 6.57344 5.52461 6.59844V6.69844Z" fill="#3E4347"/>
                        <path d="M3.55 9.90156L3.9 9.52656L3.675 9.40156L3.5 9.22656L3.55 9.17656L3.475 9.10156L3.425 9.15156L3.475 9.20156L3.45 9.22656L3.4 9.17656L3.35 9.22656L3.4 9.25156L3.35 9.30156L3.325 9.25156L3.275 9.30156L3.325 9.35156L3.275 9.37656L3.25 9.32656L3.2 9.37656L3.225 9.42656L3.2 9.45156L3.175 9.40156L3.125 9.45156L3.2 9.52656H3.225L3.25 9.50156L3.425 9.67656L3.55 9.90156Z" fill="#FFE62E"/>
                        <path d="M3.67484 9.59844C3.64984 9.57344 3.62484 9.57344 3.59984 9.59844C3.57484 9.62344 3.57484 9.64844 3.59984 9.67344L3.67484 9.74844L3.64984 9.77344L3.57484 9.69844C3.54984 9.67344 3.54984 9.62344 3.57484 9.59844C3.59984 9.57344 3.64984 9.57344 3.67484 9.59844ZM3.52484 9.52344L3.42484 9.62344L3.34984 9.54844C3.32484 9.52344 3.32484 9.47344 3.34984 9.44844C3.37484 9.42344 3.42484 9.42344 3.44984 9.44844L3.52484 9.52344ZM3.42484 9.59844L3.49984 9.52344L3.42484 9.44844C3.39984 9.42344 3.37484 9.42344 3.34984 9.44844C3.31234 9.48594 3.32484 9.49844 3.34984 9.52344L3.42484 9.59844ZM3.64984 9.39844L3.54984 9.49844L3.47484 9.42344C3.44984 9.39844 3.44984 9.34844 3.47484 9.32344C3.49984 9.29844 3.54984 9.29844 3.57484 9.32344L3.64984 9.39844ZM3.54984 9.47344L3.62484 9.39844L3.54984 9.32344C3.52484 9.29844 3.49984 9.29844 3.47484 9.32344C3.43734 9.36094 3.44984 9.37344 3.47484 9.39844L3.54984 9.47344Z" fill="#3E4347"/>
                        <path d="M4.94961 9.90156L4.59961 9.52656L4.79961 9.40156L4.97461 9.22656L4.94961 9.17656L5.02461 9.10156L5.07461 9.15156L5.02461 9.20156L5.04961 9.22656L5.09961 9.17656L5.14961 9.22656L5.09961 9.25156L5.14961 9.30156L5.17461 9.25156L5.22461 9.30156L5.17461 9.35156L5.22461 9.37656L5.24961 9.32656L5.29961 9.37656L5.24961 9.42656L5.29961 9.45156L5.32461 9.40156L5.37461 9.45156L5.29961 9.52656H5.27461L5.24961 9.50156L5.07461 9.67656L4.94961 9.90156Z" fill="#FFE62E"/>
                        <path d="M4.72461 9.64844L4.82461 9.59844C4.84961 9.57344 4.87461 9.57344 4.89961 9.59844C4.93711 9.63594 4.92461 9.64844 4.89961 9.67344L4.79961 9.74844L4.82461 9.77344L4.89961 9.69844C4.92461 9.67344 4.92461 9.62344 4.89961 9.59844C4.87461 9.57344 4.82461 9.57344 4.79961 9.59844L4.72461 9.64844ZM5.04961 9.44844C5.07461 9.42344 5.12461 9.42344 5.14961 9.44844C5.17461 9.47344 5.17461 9.52344 5.14961 9.54844L5.07461 9.62344L4.97461 9.52344L5.04961 9.44844ZM5.12461 9.52344C5.14961 9.49844 5.14961 9.47344 5.12461 9.44844C5.09961 9.42344 5.07461 9.42344 5.04961 9.44844L4.99961 9.52344L5.07461 9.59844L5.12461 9.52344ZM4.92461 9.32344C4.94961 9.29844 4.99961 9.29844 5.02461 9.32344C5.04961 9.34844 5.04961 9.39844 5.02461 9.42344L4.94961 9.49844L4.84961 9.39844L4.92461 9.32344ZM5.02461 9.39844C5.04961 9.37344 5.04961 9.34844 5.02461 9.32344C4.99961 9.29844 4.97461 9.29844 4.94961 9.32344L4.87461 9.39844L4.94961 9.47344L5.02461 9.39844Z" fill="#3E4347"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_6118_47605">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>

                    Portugese
                  </a>
                  <a href="#">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.6" clip-path="url(#clip0_6118_47661)">
                        <path d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z" fill="#ED4C5C"/>
                        <path d="M5.5 7.1L7.5 8.5L6.75 6.2L8.75 4.75H6.275L5.5 2.5L4.75 4.75H2.25L4.25 6.2L3.5 8.5L5.5 7.1ZM8.825 8.825L8.25 8.95L8.8 9.175V9.75L9.175 9.325L9.725 9.525L9.4 9.05L9.75 8.6L9.175 8.725L8.825 8.25V8.825ZM9.675 7.125L9.25 7.5L9.825 7.45L10.075 8L10.175 7.425L10.75 7.375L10.25 7.075L10.375 6.5L9.95 6.875L9.45 6.575L9.675 7.125ZM9.825 5.175L10 5.75L10.175 5.2H10.75L10.3 4.85L10.475 4.275L10 4.625L9.55 4.25L9.725 4.825L9.25 5.15L9.825 5.175ZM8.825 3.175V3.75L9.175 3.275L9.75 3.4L9.4 2.95L9.725 2.475L9.175 2.7L8.8 2.25V2.825L8.25 3.05L8.825 3.175Z" fill="#FFE62E"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_6118_47661">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>

                    Chinese
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="left">
            <router-link :to="{name: 'home'}">© 2025 TRUE WORLD</router-link>
            <div class="links">
              <router-link :to="{ name: 'cookies-policy'}">Cookies Policy</router-link>
              <router-link :to="{ name: 'privacy-policy'}">Privacy Policy</router-link>
              <router-link :to="{ name: 'terms'}">Terms and Conditions</router-link>
            </div>
          </div>
          <div class="social">
            <span>Join us</span>
            <a href="https://t.me/trueworld" target="_blank">
              <img src="/images/tg-icon.svg" alt="Telegram">
            </a>
            <a href="https://x.com/TRUExWorld" target="_blank">
              <img src="/images/Frame.svg" alt="X">
            </a>
            <a href="https://www.youtube.com/@TRUEEcosystem" target="_blank">
              <img src="/images/fa_youtube.svg" alt="Youtube">
            </a>
            <a href="https://www.linkedin.com/company/true-lab/" target="_blank">
              <img src="/images/linkedin.svg" alt="Linkedin">
            </a>
          </div>
        </div>
      </footer>
    </div>
</template>

<script>
import 'truefuture-ui/src/assets/main.less'
import empty from './empty.vue'

export default {
    components: {
        'empty': empty
    },
    computed: {
        animationKey() {
            try {
                if (this.$route.name.includes('collection')) {
                    return 'collection'
                } else if (this.$route.name.includes('market')) {
                    return this.$route.fullPath
                } else if (this.$route.fullPath.includes('app/assets')) {
                    return 'assets'
                }
                else {
                    return this.$route.fullPath
                }
            } catch {
                return this.$route.fullPath
            }
        },
        userLang() {
            try {
                if (this.$i18n.language.code && this.$store.state.user.language) {
                    return this.$i18n.language.code + this.$store.state.user.language
                }
            } catch {
                return 'auto'
            }
        }
    },
    data() {
        return {
            headerNav: [ /*{
              routeName: 'true-nto',
              isActive: ['true-nto'],
              title: 'Loyalty NTO'
            }, */{
              routeName: 'world',
              isActive: ['world'],
              title: 'TRUE World'
            }, {
              routeName: 'market',
              isActive: ['market', 'item', 'nfts', 'nfts-all', 'merchants', 'nft-item', 'collections', 'search', 'merchant', 'collection'],
              title: 'Marketplace'
            }, {
              routeName: 'community',
              isActive: ['community'],
              title: 'Community'
            }, {
              routeName: 'token',
              isActive: ['token'],
              title: 'Token'
            }, {
              routeName: 'ecosystem',
              isActive: ['ecosystem'],
              title: 'Ecosystem'
            }, /*{
              routeName: 'earn',
              isActive: ['earn'],
              title: 'Earn'
            }, *//*{
              title: 'About token',
              link: 'https://tft.club'
            }, *//*{
                routeName: 'game-world',
                isActive: ['game-world', 'for-developers'],
                title: 'Game Worlds'
            }, *//*{
                routeName: 'community',
                isActive: ['community', 'news'],
                title: 'Community'
            }, *//*{
                routeName: 'earn',
                isActive: ['earn', 'staking', 'swap'],
                title: 'Earn'
            }, *//*{
                title: 'For business',
                isActive: false,
                subNav: [{
                    title: 'About',
                    link: 'https://business.truefuture.io/about'
                }, {
                    title: 'Products',
                    link: 'https://business.truefuture.io/products'
                }, {
                    title: 'Solutions',
                    link: 'https://business.truefuture.io/solutions'
                }]
            },*/],
            footerNav: [{
                routeName: 'cookies-policy',
                isActive: ['cookies-policy'],
                title: 'Cookies Policy'
            }, {
                routeName: 'privacy-policy',
                isActive: ['privacy-policy'],
                title: 'Privacy Policy'
            }, {
                routeName: 'terms',
                isActive: ['terms'],
                title: 'Terms and Conditions'
            }, {
                routeName: 'contact-us',
                isActive: ['contact-us'],
                title: 'Contact Us'
            }, /*{
                link: 'https://whitepaper.truefuture.io/',
                title: 'White Paper'
            }*/]
        }
    },
    mounted() {
        if (process.env.NODE_ENV === 'production') {
            const gtmScript = document.createElement('script')
            gtmScript.setAttribute('async', '')
            gtmScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-706XSJRNF3')

            document.head.appendChild(gtmScript)

            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-706XSJRNF3');
        }
    }
}
</script>

<style lang="less">
.main-container {
    min-height: 100%;
    display: flex;
    flex-direction: column;

    > div {
        flex-grow: 1;
    }

    > .header {
        flex-grow: 0;
    }

    > .footer {
        flex-grow: 0;
    }

  .w-cookies-popup {
    background-color: #292D3A !important;
    box-shadow: none !important;
  }
}
body {
  background: #010209;
  .vm--overlay {
    background: #010209CC !important;
  }
}
header.header {
  > .menu {
    background: #010209;
    > .left-bar > .logo-wrapper {
      svg:nth-child(1) {
        > path:nth-child(3) {
          fill: #010209;
        }
        > path:nth-child(4) {
          fill: #010209;
        }
      }
      svg:nth-child(2) {
        display: none;
      }
    }
    > .right-bar-guest > #header-signup-button {
      border-radius: 12px;
      background: linear-gradient(90deg, #9D5BFF 0%, #563AE7 100%);
      height: 40px;
      &:hover {
        background: linear-gradient(90deg, #9D5BFF 20%, #563AE7 80%);
      }
    }
  }
  > .burger-menu > .content {
    background-color: #292D3A !important;
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: linear-gradient(90deg, #9D5BFF 0%, #563AE7 100%);
    }
  }
}
footer.true-bottom {
  height: 440px;
  background: #010209;
  > .true-footer {
    height: 320px;
    background: #C9D8FF0F;
    padding-top: 60px;
    > .container {
      display: flex;
      justify-content: space-between;
      > div {
        display: flex;
        &:nth-child(1) {gap: 60px;}
        &:nth-child(2) {gap: 80px;}
        > div {
          display: flex;
          flex-direction: column;
          > strong {
            display: flex;
            gap: 5px;
            align-items: center;
            margin-bottom: 8px;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: #FFF;
            > span {
              font-weight: 500;
              padding-top:2px;
              font-size: 8px;
              line-height: 12px;
              background: #FFFFFF1A;
              border-radius: 8px 8px 8px 0;
              width: 36px;
              height: 16px;
              display: flex;
              justify-content: center;
              align-items: center;
              text-transform: uppercase;
              color: #FFFFFF99;
            }
          }
          > .links {
            display: flex;
            flex-direction: column;
            > a {
              display: flex;
              align-items: center;
              gap: 4px;
              font-weight: 500;
              font-size: 14px;
              line-height: 24px;
              color: #FFFFFF99;
              text-wrap: nowrap;
              &:hover { color: #FFF; }
              > img {
                width: 10px;
              }
            }
          }
        }
        > .languages {
          > .links {
            > a {
              gap: 7px;
              color: #FFFFFF4D;
              pointer-events: none;
            }
          }
        }
      }
    }

    .container {
      width: 1180px;
      margin: 0 auto;
    }
    .mobile {
      display: none;
    }

    @media screen and (max-width: 1439px) {
      .container {
        width: 850px;
      }
    }
    @media screen and (max-width: 1023px) {
      .container {
        width: 670px;
      }
    }
    @media screen and (max-width: 767px) {
      .container {
        width: 100%;
        padding: 0 20px;
      }
    }
    @media screen and (max-width: 429px) {
      .container {
        width: 100%;
        padding: 0 15px;
      }
    }
  }
  > .container {
    padding-top: 38px;
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
      &:nth-child(1) {
        gap: 10px;
        flex-direction: column;
        > a {
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #FFFFFF66;
        }
        > .links {
          display: flex;
          flex-direction: row;
          gap: 15px;
          > a {
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            color: #FFFFFFCC;
            &:hover { color: #FFF; }
          }
        }
      }
      &:nth-child(2) {
        gap: 5px;
        align-items: center;
        > span {
          margin-right: 6px;
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #FFFFFF66;
        }
        > a {
          display: flex;
          width: 38px;
          height: 38px;
          justify-content: center;
          align-items: center;
          background: #FFFFFF1A;
          border-radius: 100%;
          &:hover {
            background: #FFFFFF40;
          }
        }
      }
      > div {
        display: flex;
        flex-direction: column;
        > strong {
          margin-bottom: 8px;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          color: #FFF;
        }
      }
    }
  }

  .container {
    width: 1180px;
    margin: 0 auto;
  }
  .mobile {
    display: none;
  }

  @media screen and (max-width: 1439px) {
    .container {
      width: 850px;
    }
  }
  @media screen and (max-width: 1023px) {
    .container {
      width: 670px;
    }
  }
  @media screen and (max-width: 767px) {
    .container {
      width: 100%;
      padding: 0 20px;
    }
  }
  @media screen and (max-width: 429px) {
    .container {
      width: 100%;
      padding: 0 15px;
    }
  }
}

@media screen and (max-width: 1439px) {
  footer.true-bottom {
    height: 440px;
    background: #010209;
    > .true-footer {
      height: 320px;
      padding-top: 65px;
      > .container {
        > div {
          &:nth-child(1) {gap: 30px;}
          &:nth-child(2) {gap: 20px;}
          > div {
            > strong {
              margin-bottom: 6px;
              font-size: 14px;
              line-height: 21px;
            }
            > .links {
              > a {
                gap: 7px;
                font-size: 13px;
                line-height: 24px;
              }
            }
          }
        }
      }
    }
    > .container {
      padding-top: 38px;
      display: flex;
      justify-content: space-between;
      > div {
        display: flex;
        &:nth-child(1) {
          gap: 10px;
          flex-direction: column;
          > strong {
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #FFFFFF66;
          }
          > .links {
            display: flex;
            flex-direction: row;
            gap: 15px;
            > a {
              font-weight: 500;
              font-size: 12px;
              line-height: 17px;
              color: #FFFFFFCC;
              &:hover { color: #FFF; }
            }
          }
        }
        &:nth-child(2) {
          gap: 5px;
          align-items: center;
          > span {
            margin-right: 6px;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #FFFFFF66;
          }
          > a {
            display: flex;
            width: 38px;
            height: 38px;
            justify-content: center;
            align-items: center;
            background: #FFFFFF1A;
            border-radius: 100%;
            &:hover {
              background: #FFFFFF40;
            }
          }
        }
        > div {
          display: flex;
          flex-direction: column;
          > strong {
            margin-bottom: 8px;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: #FFF;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1023px) {
  footer.true-bottom {
    height: 380px;
    background: #010209;
    > .true-footer {
      height: 260px;
      padding-top: 48px;
      > .container {
        > div {
          &:nth-child(1) {gap: 14px;}
          &:nth-child(2) {gap: 14px;}
          > div {
            > strong {
              margin-bottom: 4px;
              font-size: 14px;
              line-height: 21px;
            }
            > .links {
              > a {
                gap: 7px;
                font-size: 12px;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
    > .container {
      padding-top: 38px;
      display: flex;
      justify-content: space-between;
      > div {
        display: flex;
        &:nth-child(1) {
          gap: 10px;
          flex-direction: column;
          > strong {
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #FFFFFF66;
          }
          > .links {
            display: flex;
            flex-direction: row;
            gap: 15px;
            > a {
              font-weight: 500;
              font-size: 12px;
              line-height: 17px;
              color: #FFFFFFCC;
              &:hover { color: #FFF; }
            }
          }
        }
        &:nth-child(2) {
          gap: 5px;
          align-items: center;
          > span {
            margin-right: 6px;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #FFFFFF66;
          }
          > a {
            display: flex;
            width: 38px;
            height: 38px;
            justify-content: center;
            align-items: center;
            background: #FFFFFF1A;
            border-radius: 100%;
            &:hover {
              background: #FFFFFF40;
            }
          }
        }
        > div {
          display: flex;
          flex-direction: column;
          > strong {
            margin-bottom: 8px;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: #FFF;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  footer.true-bottom {
    height: 775px;
    > .true-footer {
      height: 520px;
      padding-top: 48px;
      > .container {
        flex-wrap: wrap;
        gap: 40px;
        > div {
          width: 100%;
          flex-wrap: wrap;
          &:nth-child(1) {gap: 0;row-gap: 14px;}
          &:nth-child(2) {gap: 0;}
          > div {
            padding: 0 7px;
            width: 50%;
            > strong {
              margin-bottom: 4px;
              font-size: 14px;
              line-height: 21px;
            }
            > .links {
              > a {
                gap: 7px;
                font-size: 12px;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
    > .container {
      padding-top: 27px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 20px;
      > div {
        display: flex;
        &:nth-child(1) {
          order: 2;
          gap: 20px;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          > strong {
            order: 2;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #FFFFFF66;
          }
          > .links {
            order: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 2px;
            > a {
              font-weight: 500;
              font-size: 12px;
              line-height: 24px;
              color: #FFFFFFCC;
              &:hover { color: #FFF; }
            }
          }
        }
        &:nth-child(2) {
          order: 1;
          gap: 5px;
          align-items: center;
          justify-content: center;
          > span { display: none; }
          > a {
            display: flex;
            width: 38px;
            height: 38px;
            justify-content: center;
            align-items: center;
            background: #FFFFFF1A;
            border-radius: 100%;
            &:hover {
              background: #FFFFFF40;
            }
          }
        }
        > div {
          display: flex;
          flex-direction: column;
          > strong {
            margin-bottom: 8px;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: #FFF;
          }
        }
      }
    }
  }
}
</style>
